import React from "react";
import { useLanguage } from "../LanguageContext";
import { mailtoWithSubject } from "../utils/mailto";

const Contact: React.FC = () => {
    const { t } = useLanguage();
    const c = t.contact;
    const titleLines = c.title.split("\n");
    const ctaLines = c.ctaTitle.split("\n");
    return (
        <section className="contact" id="contact">
            <div className="section-number">06</div>
            <div className="container">
                <div className="contact-grid">
                    <div className="contact-left">
                        <span className="section-eyebrow">{c.eyebrow}</span>
                        <h2 className="section-title">
                            {titleLines[0]}<br />{titleLines[1]}
                        </h2>
                        <div className="contact-details">
                            {c.details.map(d => (
                                <div className="contact-detail" key={d.label}>
                                    <div className="detail-label">{d.label}</div>
                                    <div className="detail-value" dir="ltr">
                                        {d.value.includes("@")
                                            ? <a href={`mailto:${d.value}`}>{d.value}</a>
                                            : d.value}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="contact-right">
                        <div className="contact-cta-card">
                            <h3>{ctaLines[0]}<br />{ctaLines[1]}</h3>
                            <p>{c.ctaDesc}</p>
                            <a className="btn-gold" href={mailtoWithSubject(t.mail.booking)}>{c.ctaBtn}</a>
                            <div className="contact-options">
                                <span>{c.opt1}</span>
                                <div className="dot-sep" />
                                <span>{c.opt2}</span>
                                <div className="dot-sep" />
                                <span>{c.opt3}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
